import React from 'react';
import Confirmation from '../confirmation/Confirmation';

const ConfirmDeleteModal = props => (
  <Confirmation title="Delete Bookmark" message={`This will remove your ${props.name} bookmark `} {...props} />
);

export default ConfirmDeleteModal;
